import type { EpisodeCategory } from '@common/enums';
import type {
    IAddCarePathServiceConsumerSettings,
    IAddCarePathServiceProviderSettings,
    IAddCarePathServiceSupervisorSettings,
    IAddServiceActivity,
    IServiceWithActivities,
} from '@common/interfaces';
import type { SettingsType } from '@common/utils/settings';
import type { IServiceOrganizationSettings } from '../../../common/interfaces/servicesByServiceGroupForEpisodeCategory';
import type { ValidationErrors } from '../../utils/validation';
import type { ServiceWithSettings } from '../pages/personalSettings/addRights/interfaces/serviceWithSettings';
import type { IEmployment } from './employment';
import type { IOrganization } from './organization';
import type { IPractitioner } from './practitioner';
import { translateKey } from '../../translate';

export enum AddRightsSteps {
    addRights = 0,
    organizationSettings = 1,
}

export enum ChooseRightsSteps {
    advancedSettings = 1,
    chooseRight = 0,
    preferenceList = 2,
}

export type ProviderService = ServiceWithSettings<IAddCarePathServiceProviderSettings> & {
    preferredServiceOrganizationConsumers?: string[];
};

export interface IServiceActivitiesWithSettings extends IServiceWithActivities<IAddServiceActivity> {
    settings?: Partial<SettingsType>;
}

export interface ICareProviderAddRightsState {
    addServiceReader?: boolean;
    chooseRightsStep: ChooseRightsSteps;
    consumerServices: ServiceWithSettings<IAddCarePathServiceConsumerSettings>[];
    currentStep: AddRightsSteps;
    employment?: IEmployment;
    episodeCategory?: EpisodeCategory;
    errors: ValidationErrors;
    organization?: IOrganization;
    practitioner?: IPractitioner;
    providerServices: ProviderService[];
    serviceEmploymentActivities: IServiceActivitiesWithSettings[];
    serviceOrganizationSettings: IServiceOrganizationSettings[];
    servicesMissingPreferredServiceConsumers?: string[];
    supervisorServices: ServiceWithSettings<IAddCarePathServiceSupervisorSettings & { id: string }>[];
}

export const addCarePathSteps = () => [
    { title: translateKey('episodeCategory.assignRoles') },
    { title: translateKey('episodeCategory.organizationSettings') },
];
